<template>
  <el-dialog
    title="群组详情"
    :visible="visible"
    width="700px"
    @close="handleClose"
  >
    <div v-if="groupData" class="group-detail">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="群组ID">
          {{ groupData.groupId }}
        </el-descriptions-item>

        <el-descriptions-item label="群名称">
          <div class="group-info">
            <el-avatar
              :size="30"
              :src="groupData.avatar"
              style="margin-right: 8px"
            >
              {{ groupData.groupName ? groupData.groupName.charAt(0) : "G" }}
            </el-avatar>
            {{ groupData.groupName }}
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="群主">
          {{ groupData.ownerName }}
        </el-descriptions-item>

        <el-descriptions-item label="群类型">
          <el-tag :type="groupData.groupType === 0 ? 'primary' : 'success'">
            {{ groupData.groupType | groupTypeText }}
          </el-tag>
        </el-descriptions-item>

        <el-descriptions-item label="群类别">
          <el-tag :type="groupData.isPrivate ? 'warning' : 'info'">
            {{ groupData.isPrivate ? "私有群" : "公开群" }}
          </el-tag>
        </el-descriptions-item>

        <el-descriptions-item label="状态">
          <el-tag :type="groupData.status === 0 ? 'success' : 'danger'">
            {{ groupData.status | statusText }}
          </el-tag>
        </el-descriptions-item>

        <el-descriptions-item label="成员数量">
          {{ groupData.memberCount || 0 }} /
          {{ groupData.maxMemberCount || 500 }}
        </el-descriptions-item>

        <el-descriptions-item label="最后活跃时间">
          {{ groupData.lastActiveTime | formatDate }}
        </el-descriptions-item>

        <el-descriptions-item label="创建时间">
          {{ groupData.createdTime | formatDate }}
        </el-descriptions-item>

        <el-descriptions-item label="更新时间">
          {{ groupData.updatedTime | formatDate }}
        </el-descriptions-item>

        <el-descriptions-item
          v-if="groupData.description"
          label="群描述"
          :span="2"
        >
          {{ groupData.description }}
        </el-descriptions-item>

        <el-descriptions-item v-if="groupData.remark" label="备注" :span="2">
          {{ groupData.remark }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 成员列表预览 -->
      <div class="group-members" style="margin-top: 20px">
        <h4>群成员 (前10个)</h4>
        <el-table :data="groupMembers" size="small">
          <el-table-column prop="nickName" label="昵称" width="120">
            <template slot-scope="scope">
              <div class="member-info">
                <el-avatar
                  :size="24"
                  :src="scope.row.avatar"
                  style="margin-right: 8px"
                >
                  {{ scope.row.nickName ? scope.row.nickName.charAt(0) : "U" }}
                </el-avatar>
                {{ scope.row.nickName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="role" label="角色" width="80">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.role === 'owner'
                    ? 'danger'
                    : scope.row.role === 'admin'
                    ? 'warning'
                    : 'info'
                "
                size="mini"
              >
                {{ scope.row.role | memberRoleText }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="加入时间" width="150">
            <template slot-scope="scope">
              {{ scope.row.joinTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column prop="lastActiveTime" label="最后活跃" width="150">
            <template slot-scope="scope">
              {{ scope.row.lastActiveTime | formatDate }}
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align: center; margin-top: 10px">
          <el-button size="small" @click="showAllMembers"
            >查看全部成员</el-button
          >
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getGroupMembers } from "@/api/group";

export default {
  name: "GroupDetail",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    groupData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      groupMembers: [],
    };
  },
  watch: {
    visible(val) {
      if (val && this.groupData) {
        this.loadGroupMembers();
      }
    },
  },
  methods: {
    async loadGroupMembers() {
      try {
        const response = await getGroupMembers(this.groupData.id, { size: 10 });
        this.groupMembers = response.data || [];
      } catch (error) {
        console.error("加载群成员失败:", error);
        // 模拟数据
        this.groupMembers = [
          {
            nickName: "群主用户",
            role: "owner",
            joinTime: new Date(Date.now() - 86400000 * 30).toISOString(),
            lastActiveTime: new Date().toISOString(),
          },
          {
            nickName: "管理员1",
            role: "admin",
            joinTime: new Date(Date.now() - 86400000 * 20).toISOString(),
            lastActiveTime: new Date(Date.now() - 3600000).toISOString(),
          },
          {
            nickName: "普通成员1",
            role: "member",
            joinTime: new Date(Date.now() - 86400000 * 10).toISOString(),
            lastActiveTime: new Date(Date.now() - 7200000).toISOString(),
          },
        ];
      }
    },

    showAllMembers() {
      this.$emit("show-members", this.groupData);
    },

    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-detail {
  .group-info {
    display: flex;
    align-items: center;
  }

  .group-members {
    h4 {
      margin-bottom: 10px;
      color: #303133;
    }

    .member-info {
      display: flex;
      align-items: center;
    }
  }
}
</style>
